__turbopack_context__.v({
  "changeOwnerModal": "ConnectionChangeOwnerModal-module__T4XBAa__changeOwnerModal",
  "divider": "ConnectionChangeOwnerModal-module__T4XBAa__divider",
  "menuItem": "ConnectionChangeOwnerModal-module__T4XBAa__menuItem",
});
